import { OptionsType } from '@openx/types/options.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useOldAdPlacementOptionsFetch() {
  const { t } = useTranslation();
  const {
    isLoading: isAdPlacementLoading,
    data: adPlacement,
    refetch: refetchAdPlacement,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Ad Placement options'),
    optionType: OptionsType.OLD_AD_PLACEMENT,
  });

  return {
    adPlacement,
    isAdPlacementLoading,
    refetchAdPlacement,
  };
}
